import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import Scale from 'components/Scale';

import {
  Container,
  Task,
  TaskTitle,
  TaskDescription,
  StyledLink,
  ScaleContainer,
} from './styled';

const ShortDescription = ({ openModal, grades, description }) => (
  <Container>
    <Task>
      <TaskTitle>Description</TaskTitle>
      <TaskDescription>{description}</TaskDescription>
      <StyledLink>
        <Button onClick={openModal}>Resources/Materials</Button>
      </StyledLink>
    </Task>
    {grades[0] &&
      <ScaleContainer>
        <Scale grades={grades} />
      </ScaleContainer>
    }
  </Container>
);

ShortDescription.propTypes = {
  openModal: PropTypes.func.isRequired,
  grades: PropTypes.array.isRequired,
  description: PropTypes.string.isRequired,
};

export default ShortDescription;
